import React, { useState } from "react";
import { C } from "@tokens";

/**
 * Button — primitivo de botão com variantes primary/secondary/ghost,
 * seguindo o design language do v45 (pill rounded, sem border dura).
 *
 * @param {React.ReactNode} children
 * @param {"primary"|"secondary"|"ghost"} [variant]
 * @param {"sm"|"md"|"lg"} [size]
 * @param {boolean} [block]     - largura 100%
 * @param {boolean} [disabled]
 * @param {function} [onClick]
 */
export default function Button({
  children,
  variant = "primary",
  size = "md",
  block = false,
  disabled = false,
  onClick,
  type = "button",
  style: styleOverride = {},
  ...rest
}) {
  const [hov, setHov] = useState(false);

  const sizes = {
    sm: { padding: "6px 12px", fontSize: 11 },
    md: { padding: "8px 16px", fontSize: 12 },
    lg: { padding: "12px 22px", fontSize: 14 },
  };

  const variants = {
    primary: {
      background: hov && !disabled ? C.g800 : C.g700,
      color: C.white,
      border: "none",
      boxShadow: "0 1px 3px rgba(0,0,0,.08)",
    },
    secondary: {
      background: hov && !disabled ? C.surf3 : C.surface,
      color: C.text,
      border: `1px solid ${C.border}`,
      boxShadow: "0 1px 2px rgba(0,0,0,.03)",
    },
    ghost: {
      background: hov && !disabled ? C.surf3 : "transparent",
      color: C.text3,
      border: "none",
      boxShadow: "none",
    },
  };

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        ...sizes[size],
        ...variants[variant],
        borderRadius: 10,
        fontWeight: 600,
        fontFamily: "inherit",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        width: block ? "100%" : "auto",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        transition: "background .15s",
        letterSpacing: "-0.01em",
        ...styleOverride,
      }}
      {...rest}
    >
      {children}
    </button>
  );
}
